import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss']
})
export class CustomTooltipComponent {
  @Output() showTooltip :EventEmitter<boolean>=new EventEmitter();
  @Input() description :string;
  @Input() tooltipTitle : string;
  @Input() linkTitle: string;
  @Input() link: string;
  @Input() linkBlock=false;
  @HostListener('document:click', ['$event'])
  clickOutSide(event) {
    if(event && (event.pointerType === "mouse" || (event.pointerType === "touch")) && 
       !(event.target).closest(".tooltiptext") && !(event.target).closest(".tooltip-icon")){
        this.close();
    }
  }
  close(){
    this.showTooltip.emit(false);
  }
}